import { render, staticRenderFns } from "./LeadOrderReceipts.vue?vue&type=template&id=fb0929fa&"
import script from "./LeadOrderReceipts.vue?vue&type=script&lang=js&"
export * from "./LeadOrderReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports